import React, { useEffect, useState } from 'react'
import { FaChevronCircleLeft } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { Outlet, useNavigate, useParams } from 'react-router'
import { State } from '../../../redux/store'
import { DefaultDoctorInterface, DoctorInterface } from '../types'
import SideBarAbout from './SideBarAbout'
import { useDispatch } from 'react-redux'
import { getRegFormsApi } from '../../../redux/regForm/regFormApiCalls'
import { AboutDoctorContext } from './types'
import SuccessMsg from '../../../Messages/SuccessMsg'
import { getDoctorsApi } from '../../../redux/doctors/doctorApiCalls'
import { getCabinetsApi } from '../../../redux/cabinets/cabinetApiCalls'
import { getMedecinTypesApi } from '../../../redux/medecinType/medecinTypeApiCalls'

const AboutDoctor = () => {
  const navigate = useNavigate()
  const { doctorId } = useParams()
  const { doctors } = useSelector((state: State) => state.doctors)
  const { userData } = useSelector((state: State) => state.login)
  const [currentDoctor, setCurrentDoctor] = useState<DoctorInterface>(DefaultDoctorInterface)

  useEffect(() => {
    setCurrentDoctor(doctors.find((doctor: DoctorInterface) => doctor?._id === doctorId) ?? DefaultDoctorInterface)
  }, [doctorId, doctors]) 
  
  const dispatch: any = useDispatch()

  useEffect(() => {
    const fetchApis = async () => {
      await dispatch(getRegFormsApi(doctorId))
      await dispatch(getDoctorsApi())
      await dispatch(getCabinetsApi())
      await dispatch(getMedecinTypesApi())
    }
    fetchApis()
  }, [dispatch, doctorId])

  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  return (
    <AboutDoctorContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg
    }}>
      <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/>
      <div className="flex justify-between gap-2 mt-20">
        <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => userData.user && navigate(`/doctor`)}/>
        <h1 className='text-center md:text-2xl font-bold'>{currentDoctor.fullName}</h1>
        <span></span>
      </div>
      <section className='mt-4'>
        <SideBarAbout />
        <Outlet />
      </section>
    </AboutDoctorContext.Provider>
  )
}

export default AboutDoctor